

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const CREATEAWARD= createAsyncThunk(
  "createAward/createAward",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const createAwardSlice = createSlice({
  name: "createAwardSlice",
  initialState: {
    createAward: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfcreateAward: (state) => {
        state.createAward.loading = false
        state.createAward.error = false
        state.createAward.data = []
        state.createAward.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(CREATEAWARD.fulfilled, (state, action) => {
      state.createAward = {
        ...state.createAward,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CREATEAWARD.pending, (state, action) => {
      state.createAward = {
        ...state.createAward,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CREATEAWARD.rejected, (state, action) => {
      state.createAward = {
        ...state.createAward,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const createAwardAction = {
    CREATEAWARD,
};

export { createAwardAction };
export default createAwardSlice.reducer;
export const {setInitialStateOfcreateAward} = createAwardSlice.actions